var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: {
        title: "New Employee",
        label: "New Employee",
        "btn-class": "btn btn-default",
        "modal-class": "text-left"
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function(props) {
            return [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  class: { disabled: _vm.processing },
                  attrs: { disabled: _vm.processing },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submit(props)
                    }
                  }
                },
                [
                  _vm.processing
                    ? _c("span", [
                        _c("i", { staticClass: "fa fa-spin fa-spinner" }),
                        _vm._v("\n    Saving...\n  ")
                      ])
                    : _c("span", [_vm._v("\n    Save\n  ")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return props.close()
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "margin-bottom-3x" }, [
          _c("label", [_vm._v("Email")]),
          _vm._v(" "),
          _c("div", { class: { "input-group": !_vm.selectedUser } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email"
                }
              ],
              staticClass: "form-control",
              attrs: { disabled: _vm.selectedUser, type: "text" },
              domProps: { value: _vm.form.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            !_vm.selectedUser
              ? _c("span", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      class: { disabled: _vm.checkingEmail },
                      attrs: { disabled: _vm.checkingEmail, type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.checkEmail.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm.checkingEmail
                        ? _c("span", [_vm._v("Checking...")])
                        : _c("span", [_vm._v("Check if exists")])
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.errors.email
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v("\n      " + _vm._s(_vm.errors.email[0]) + "\n    ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.selectedUser
          ? _c("div", { staticClass: "margin-bottom-3x" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  on: { click: _vm.unSelectUser }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-angle-left",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v("\n      Back\n    ")
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.selectedUser
          ? _c("div", {}, [
              _c("div", { staticClass: "margin-bottom-3x" }, [
                _c("label", [_vm._v("Name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "name", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.name
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errors.name[0]) + "\n      "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-3x" }, [
                _c("label", [_vm._v("Phone")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.phone,
                      expression: "form.phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "phone", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.phone
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errors.phone[0]) + "\n      "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Country")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.country_id,
                        expression: "form.country_id"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Country" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "country_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.countries, function(country) {
                    return _c("option", { domProps: { value: country.id } }, [
                      _vm._v(_vm._s(country.name))
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.errors.country_id
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.country_id[0]) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("State")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.state_id,
                        expression: "form.state_id"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Country" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "state_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.states, function(state) {
                    return _c("option", { domProps: { value: state.id } }, [
                      _vm._v(_vm._s(state.name))
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.errors.state_id
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.state_id[0]) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("City")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.form.city,
                      expression: "form.city",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "City name" },
                  domProps: { value: _vm.form.city },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "city", $event.target.value.trim())
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.city
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errors.city[0]) + "\n      "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-3x" }, [
                _c("label", [_vm._v("Zip Code")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.zip_code,
                      expression: "form.zip_code"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.zip_code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "zip_code", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.zip_code
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.zip_code[0]) +
                          "\n      "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canchangeReportStartDate
          ? _c("div", { staticClass: "margin-bottom-3x" }, [
              _c("label", [_vm._v("Report Start Date")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("datepicker", {
                    staticClass: "form-control",
                    attrs: { "min-date": "none", placeholder: "MM/DD/YYYY" },
                    model: {
                      value: _vm.form.report_start_date,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "report_start_date", $$v)
                      },
                      expression: "form.report_start_date"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.form.report_start_date = null
                          }
                        }
                      },
                      [_vm._v("\n          Clear\n        ")]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v("Leave blank for unrestricted report access.")
              ]),
              _vm._v(" "),
              _vm.errors.report_start_date
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.errors.report_start_date[0]) +
                        "\n    "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {}, [
          _c("label", [_vm._v("\n      Role:\n    ")]),
          _vm._v(" "),
          _vm.errors.role
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v("\n      " + _vm._s(_vm.errors.role[0]) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "row no-padding-all radio" },
            _vm._l(_vm.roles, function(role) {
              return _c(
                "li",
                { staticClass: "col-sm-4 no-bullet margin-bottom-2x" },
                [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.role,
                          expression: "form.role"
                        }
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: role.id,
                        checked: _vm._q(_vm.form.role, role.id)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "role", role.id)
                        }
                      }
                    }),
                    _vm._v("\n          " + _vm._s(role.display_name)),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(role.description))])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bca63310", { render: render, staticRenderFns: staticRenderFns })
  }
}